import script from "./Upload.vue?vue&type=script&lang=ts&setup=true"
export * from "./Upload.vue?vue&type=script&lang=ts&setup=true"

import "./Upload.vue?vue&type=style&index=0&id=27998ae7&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27998ae7"]])

export default __exports__